import React from "react";

export function Apps() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.59259 22C6.02444 22 7.18518 20.8393 7.18518 19.4074C7.18518 17.9756 6.02444 16.8148 4.59259 16.8148C3.16074 16.8148 2 17.9756 2 19.4074C2 20.8393 3.16074 22 4.59259 22Z"
        fill="#29394D"
      />
      <path
        d="M12 22C13.4319 22 14.5926 20.8393 14.5926 19.4074C14.5926 17.9756 13.4319 16.8148 12 16.8148C10.5682 16.8148 9.40741 17.9756 9.40741 19.4074C9.40741 20.8393 10.5682 22 12 22Z"
        fill="#29394D"
      />
      <path
        d="M19.4073 22C20.8392 22 21.9999 20.8393 21.9999 19.4074C21.9999 17.9756 20.8392 16.8148 19.4073 16.8148C17.9755 16.8148 16.8147 17.9756 16.8147 19.4074C16.8147 20.8393 17.9755 22 19.4073 22Z"
        fill="#29394D"
      />
      <path
        d="M4.59259 14.5926C6.02444 14.5926 7.18518 13.4318 7.18518 12C7.18518 10.5681 6.02444 9.4074 4.59259 9.4074C3.16074 9.4074 2 10.5681 2 12C2 13.4318 3.16074 14.5926 4.59259 14.5926Z"
        fill="#29394D"
      />
      <path
        d="M12 14.5926C13.4319 14.5926 14.5926 13.4318 14.5926 12C14.5926 10.5681 13.4319 9.4074 12 9.4074C10.5682 9.4074 9.40741 10.5681 9.40741 12C9.40741 13.4318 10.5682 14.5926 12 14.5926Z"
        fill="#29394D"
      />
      <path
        d="M19.4073 14.5926C20.8392 14.5926 21.9999 13.4318 21.9999 12C21.9999 10.5681 20.8392 9.4074 19.4073 9.4074C17.9755 9.4074 16.8147 10.5681 16.8147 12C16.8147 13.4318 17.9755 14.5926 19.4073 14.5926Z"
        fill="#29394D"
      />
      <path
        d="M4.59259 7.18518C6.02444 7.18518 7.18518 6.02444 7.18518 4.59259C7.18518 3.16074 6.02444 2 4.59259 2C3.16074 2 2 3.16074 2 4.59259C2 6.02444 3.16074 7.18518 4.59259 7.18518Z"
        fill="#29394D"
      />
      <path
        d="M12 7.18518C13.4319 7.18518 14.5926 6.02444 14.5926 4.59259C14.5926 3.16074 13.4319 2 12 2C10.5682 2 9.40741 3.16074 9.40741 4.59259C9.40741 6.02444 10.5682 7.18518 12 7.18518Z"
        fill="#29394D"
      />
      <path
        d="M19.4073 7.18518C20.8392 7.18518 21.9999 6.02444 21.9999 4.59259C21.9999 3.16074 20.8392 2 19.4073 2C17.9755 2 16.8147 3.16074 16.8147 4.59259C16.8147 6.02444 17.9755 7.18518 19.4073 7.18518Z"
        fill="#29394D"
      />
    </svg>
  );
}
